import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import ColorModeContext from "../../layout/themeContext";
import defaultLogoLight from "../../assets/logo.png";
import defaultLogoDark from "../../assets/logo-black.png";

const Logo = ({ className = "", linkTo = "/", size = "medium" }) => {
  const theme = useContext(ColorModeContext);
  const [imgError, setImgError] = useState(false);

  const getLogo = () => {
    if (theme.mode === "light") {
      return imgError
        ? defaultLogoLight
        : theme.appLogoLight || defaultLogoLight;
    } else {
      return imgError ? defaultLogoDark : theme.appLogoDark || defaultLogoDark;
    }
  };

  const sizeMap = {
    small: { height: "30px", maxWidth: "120px", marginTop: "0px" },
    medium: { height: "55px", maxWidth: "186px", marginTop: "15px" },
    large: { height: "60px", maxWidth: "200px", marginTop: "0px" },
  };

  const handleError = () => {
    setImgError(true);
  };

  const TextLogo = () => (
    <div
      className="text-logo"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: sizeMap[size].height,
        minWidth: "80px",
        maxWidth: sizeMap[size].maxWidth,
        backgroundColor:
          theme.mode === "light"
            ? theme.primaryColorLight
            : theme.primaryColorDark,
        color: "white",
        fontWeight: "bold",
        borderRadius: "5px",
        padding: "0 12px",
        fontSize:
          size === "small" ? "12px" : size === "medium" ? "14px" : "16px",
      }}
    >
      {theme.appName || "OmniPlay"}
    </div>
  );

  const logoUrl = getLogo();

  return (
    <Link to={linkTo} className={`logo-link ${className}`}>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={theme.appName || "OmniPlay"}
          className="logo-img"
          style={{
            height: sizeMap[size].height,
            maxWidth: sizeMap[size].maxWidth,
            marginTop: sizeMap[size].marginTop,
            objectFit: "contain",
          }}
          onError={handleError}
        />
      ) : (
        <TextLogo />
      )}
    </Link>
  );
};

export default Logo;
